import * as React from 'react';
import { CheckOutStateContext } from '../../providers/CheckOutStateContextProvider';
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe, StripeElementsOptions} from '@stripe/stripe-js';
import StripePaymentComplete from './StripePaymentComplete'

export default function StripePaymentCallback() {
    const checkOutState = React.useContext(CheckOutStateContext);

    const stripePromise = loadStripe(checkOutState.state.stripeApiKey!!, {stripeAccount: checkOutState.state.stripeAccountId!!});
    const clientSecret = new URLSearchParams(window.location.search).get(
        'payment_intent_client_secret'
    );

    const paymentElementOptions: StripeElementsOptions = {
        clientSecret: clientSecret!!,
        appearance: {
            theme: 'flat',
        },
    };

    return (
        <div>
            {clientSecret !== null &&
                <Elements stripe={stripePromise} options={paymentElementOptions}>
                    <StripePaymentComplete clientSecret={clientSecret} />
                </Elements>
            }
        </div>
    );
}

